<template>
  <span>
    <v-row dense justify="center">
      <v-col cols="12" md="auto" class="flex-md-grow-1">
        <v-card class="my-1 elevation-0" style="height: 98.5%;">
          <v-card-text>
            <kpis-by-municipio-data-table
              :dadosKpisByMunicipio="dadosKpisAgregados"
              :traducaoIndicadores="traducaoIndicadores"
              :loading="loadingPorChave.dadosKpisAgregados"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="auto" class="flex-md-grow-1">
        <v-card class="my-1 elevation-0">
          <v-card-text>
            <kpis-by-municipio-map
              :dadosKpisByMunicipio="dadosKpisAgregados"
              :loading="loadingPorChave.dadosKpisAgregados"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      dense
      justify="center"
      v-for="chart in chartDataComputed"
      :key="chart.title"
    >
      <v-col cols="12">
        <v-card-charts-dashboard
          :title="chart.title"
          :options="chart.options"
          :deep-copy-on-update="false"
          :is-loading="chart.loading"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
import { mapState } from "vuex";
import DashboardReligacaoService from "@/services/DashboardReligacao.js";
import KpisByMunicipioMap from "@/components/dashboardReligacao/KpisByMunicipioMap.vue";
import KpisByMunicipioDataTable from "@/components/dashboardReligacao/KpisByMunicipioDataTable.vue";
import Highcharts from "highcharts";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
HighchartsNoData(Highcharts);
import exporting from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
import boost from "highcharts/modules/boost";

exporting(Highcharts);
exportData(Highcharts);
boost(Highcharts);

export default {
  name: "DashboardReligacaoVisaoMunicipios",
  components: {
    KpisByMunicipioMap,
    KpisByMunicipioDataTable,
    VCardChartsDashboard: () => import("@/components/base/VCardChartsDashboard.vue"),
  },
  props: {
    activatedTab: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      graficoIncidenciaOptions: {},
      graficoQtndTotalOptions: {},
      chartPercentualServicosReligacaoConcluidosForaPrazoOptions: {},
      chartQntdServicosDescumpridosOptions: {},
      chartQntdServicosRealizadosOptions: {},
      dadosKpisAgregados: {},
      traducaoIndicadores: {
        incidencia_suspensoes_indevidas:
          "Incidência de Suspensões Indevidas (por 10.000 UC)",
        qtnd_total_suspensoes_indevidas:
          "Quantidade Total de Suspensões Indevidas",
        percentual_servicos_fora_prazo:
          "Percentual de Serviços Fora do Prazo (%)",
        qntd_servicos_descumpridos: "Quantidade de Serviços Descumpridos",
        qntd_servicos_realizados: "Quantidade de Serviços Realizados",
      },
      debounceTimer: null,
      loadingPorChave: {
        dadosKpisAgregados: false,
      },
      chartData: [
        {
          title: "Incidência de Suspensões Indevidas",
          chartOptionsKey: "graficoIncidenciaOptions",
        },
        {
          title: "Quantidade Total de Suspensões Indevidas",
          chartOptionsKey: "graficoQtndTotalOptions",
        },
        {
          title: "Percentual de Serviços Concluídos Fora do Prazo (%)",
          chartOptionsKey:
            "chartPercentualServicosReligacaoConcluidosForaPrazoOptions",
        },
        {
          title: "Quantidade de Serviços Religatórios Descumpridos",
          chartOptionsKey: "chartQntdServicosDescumpridosOptions",
        },
        {
          title: "Quantidade de Serviços Realizados",
          chartOptionsKey: "chartQntdServicosRealizadosOptions",
        },
      ],
    };
  },
  computed: {
    ...mapState("parametrosDashboardReligacao", [
      "competenciaDe",
      "competenciaAte",
      "regionalSelecionada",
      "visaoGraficos",
      "quantidadeMunicipios",
      "servicosReligacaoSelecionados",
    ]),
    chartDataComputed() {
      const isLoading = !!this.loadingPorChave.dadosKpisAgregados;
      return this.chartData.map((chart) => ({
        ...chart,
        loading: isLoading,
        options: this[chart.chartOptionsKey],
      }));
    },
  },
  watch: {
    competenciaDe() {
      this.getDados();
    },
    competenciaAte() {
      this.getDados();
    },
    regionalSelecionada() {
      this.getDados();
    },
    visaoGraficos() {
      this.getDados();
    },
    quantidadeMunicipios() {
      this.getDadosComDebounce();
    },
    servicosReligacaoSelecionados() {
      this.getDadosComDebounce();
    },

    activatedTab(newVal) {
      if (newVal !== 1) return;
      this.getDados();
    },
  },
  mounted() {
    this.getDados();
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
    this.limparDados();
  },
  methods: {
    getDados() {
      if (this.activatedTab !== 1) return;

      this.loadingPorChave.dadosKpisAgregados = true;
      this.$emit("updateLoadingDados", true);

      this.$nextTick().then(() => {
        this.getDadosKpisAgregados()
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao recuperar dados", "", {
              position: "topRight",
            });
          })
          .finally(() => {
            this.loadingPorChave.dadosKpisAgregados = false;
            this.$emit("updateLoadingDados", false);
          });
      });
    },
    getDadosComDebounce() {
      if (this.activatedTab !== 1) return;

      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }

      this.loadingPorChave.dadosKpisAgregados = true;
      this.$emit("updateLoadingDados", true);

      this.debounceTimer = setTimeout(() => {
        this.debounceTimer = null;
        this.getDados();
      }, 500);
    },

    getDadosKpisAgregados() {
      return DashboardReligacaoService.getKpisAgregadosPorMunicipio(
        this.regionalSelecionada,
        this.competenciaDe,
        this.competenciaAte,
        this.servicosReligacaoSelecionados,
      )
        .then((res) => {
          this.dadosKpisAgregados = res;
          this.gerarGraficoIncidencia();
          this.gerarGraficoQtndTotal();
          this.gerarGraficoPercentual();
          this.gerarGraficoDescumpridos();
          this.gerarGraficoDescumpridosProcedimentoIrregular();
          this.gerarGraficoRealizados();
        })
        .catch((err) => {
          throw err;
        });
    },
    obterTopMunicipios(dadosSomados, quantidade) {
      const dadosOrdenados = Object.entries(dadosSomados).sort(
        (a, b) => b[1] - a[1],
      );

      const dadosFiltrados =
        quantidade === 0 ? dadosOrdenados : dadosOrdenados.slice(0, quantidade);

      return dadosFiltrados.reduce((acc, [municipio, valor]) => {
        acc[municipio] = valor;
        return acc;
      }, {});
    },

    criarOpcoesGrafico(
      titulo,
      municipios,
      valores,
      sufixo = "",
      valorReferencia = null,
    ) {
      return {
        chart: {
          type: "column",
          zooming: { type: "x" },
          animation: {
            duration: 800,
          },
        },
        xAxis: {
          categories: municipios,
          title: {
            text: "Municípios",
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: titulo,
          },
          plotLines: valorReferencia
            ? [
                {
                  value: valorReferencia,
                  color: this.$vuetify.theme.themes.light.success,
                  width: 2,
                  zIndex: 5,
                  label: {
                    text: `Limite de Referência (${valorReferencia}%)`,
                    align: "right",
                    verticalAlign: "top",
                    style: {
                      color: this.$vuetify.theme.themes.light.success,
                      fontSize: "14px",
                      fontWeight: "bold",
                    },
                  },
                },
              ]
            : [],
        },
        title: {
          text: "",
        },
        tooltip: {
          valueSuffix: sufixo,
        },
        plotOptions: {
          series: {
            animation: {
              duration: 800,
            },
          },
        },
        series: [
          {
            name: titulo,
            data: valores,
            color: this.$vuetify.theme.themes.light.primary,
          },
        ],
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: true,
          buttons: {
            contextButton: {
              menuItems: [
                "downloadPNG",
                "downloadJPEG",
                "downloadPDF",
                "downloadSVG",
              ],
            },
          },
        },
      };
    },

    gerarGraficoIncidencia() {
      const dadosIncidencia = {};
      Object.entries(this.dadosKpisAgregados).forEach(([municipio, dados]) => {
        dadosIncidencia[municipio] = dados.incidencia_suspensoes_indevidas;
      });

      const topMunicipios = this.obterTopMunicipios(
        dadosIncidencia,
        this.quantidadeMunicipios,
      );
      const municipios = Object.keys(topMunicipios);
      const valores = Object.values(topMunicipios);

      this.graficoIncidenciaOptions = this.criarOpcoesGrafico(
        "Incidência",
        municipios,
        valores,
        "",
        3,
      );
    },
    gerarGraficoQtndTotal() {
      const dadosQtnd = {};
      Object.entries(this.dadosKpisAgregados).forEach(([municipio, dados]) => {
        dadosQtnd[municipio] = dados.qtnd_total_suspensoes_indevidas || 0;
      });

      const topMunicipios = this.obterTopMunicipios(
        dadosQtnd,
        this.quantidadeMunicipios,
      );
      const municipios = Object.keys(topMunicipios);
      const valores = Object.values(topMunicipios);

      this.graficoQtndTotalOptions = this.criarOpcoesGrafico(
        "Quantidade",
        municipios,
        valores,
      );
    },

    gerarGraficoPercentual() {
      const dadosPercentual = {};
      Object.entries(this.dadosKpisAgregados).forEach(([municipio, dados]) => {
        dadosPercentual[municipio] = dados.percentual_servicos_fora_prazo || 0;
      });

      const topMunicipios = this.obterTopMunicipios(
        dadosPercentual,
        this.quantidadeMunicipios,
      );
      const municipios = Object.keys(topMunicipios);
      const valores = Object.values(topMunicipios);

      this.chartPercentualServicosReligacaoConcluidosForaPrazoOptions = this.criarOpcoesGrafico(
        "Percentual",
        municipios,
        valores,
        "%",
        5,
      );
    },

    gerarGraficoDescumpridos() {
      const dadosDescumpridos = {};
      Object.entries(this.dadosKpisAgregados).forEach(([municipio, dados]) => {
        dadosDescumpridos[municipio] = dados.qntd_servicos_descumpridos;
      });

      const topMunicipios = this.obterTopMunicipios(
        dadosDescumpridos,
        this.quantidadeMunicipios,
      );
      const municipios = Object.keys(topMunicipios);
      const valores = Object.values(topMunicipios);

      this.chartQntdServicosDescumpridosOptions = this.criarOpcoesGrafico(
        "Quantidade",
        municipios,
        valores,
      );
    },

    gerarGraficoDescumpridosProcedimentoIrregular() {
      const dadosDescumpridos = {};
      Object.entries(this.dadosKpisAgregados).forEach(([municipio, dados]) => {
        dadosDescumpridos[municipio] = dados.qntd_servicos_descumpridos || 0;
      });

      const topMunicipios = this.obterTopMunicipios(
        dadosDescumpridos,
        this.quantidadeMunicipios,
      );
      const municipios = Object.keys(topMunicipios);
      const valores = Object.values(topMunicipios);

      this.chartQntdServicosDescumpridosPorProcedimentoIrregularComprovadoOptions = this.criarOpcoesGrafico(
        "Quantidade",
        municipios,
        valores,
      );
    },

    gerarGraficoRealizados() {
      const dadosRealizados = {};
      Object.entries(this.dadosKpisAgregados).forEach(([municipio, dados]) => {
        dadosRealizados[municipio] = dados.qntd_servicos_realizados || 0;
      });

      const topMunicipios = this.obterTopMunicipios(
        dadosRealizados,
        this.quantidadeMunicipios,
      );
      const municipios = Object.keys(topMunicipios);
      const valores = Object.values(topMunicipios);

      this.chartQntdServicosRealizadosOptions = this.criarOpcoesGrafico(
        "Quantidade",
        municipios,
        valores,
      );
    },
    limparDados() {
      this.dadosKpisAgregados = {};
      this.graficoIncidenciaOptions = {};
      this.graficoQtndTotalOptions = {};
      this.chartPercentualServicosReligacaoConcluidosForaPrazoOptions = {};
      this.chartQntdServicosDescumpridosOptions = {};
      this.chartQntdServicosRealizadosOptions = {};
    },
  },
};
</script>

<style></style>
